import { db, storage } from "../firebase";
import {
  collection,
  doc,
  setDoc,
  updateDoc,
  deleteDoc,
  getDocs,
  serverTimestamp,
} from "firebase/firestore";
import {
  ref,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { uploadOptimizedImage } from "@/lib/uploadImage";
import { sortByOrder } from "./reorderService";

const TRANSPORT_COLLECTION = "transport";

/** Generates a fresh id for a new transport draft — reused across image
 * upload + final submit, same pattern as generateFerryId/generateGatewayId. */
export function generateTransportId() {
  return doc(collection(db, TRANSPORT_COLLECTION)).id;
}

export async function createTransport(id, payload) {
  await setDoc(doc(db, TRANSPORT_COLLECTION, id), {
    ...payload,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return id;
}

export async function updateTransport(id, payload) {
  await updateDoc(doc(db, TRANSPORT_COLLECTION, id), {
    ...payload,
    updatedAt: serverTimestamp(),
  });
  return id;
}

export async function deleteTransport(id, imageUrl) {
  await deleteDoc(doc(db, TRANSPORT_COLLECTION, id));
  if (imageUrl) {
    try {
      await deleteObject(ref(storage, imageUrl));
    } catch (err) {
      // Image may already be gone or URL may not be a storage ref
      // (e.g. external URL) — don't block the delete on cleanup failing.
      console.warn("Transport image cleanup failed:", err);
    }
  }
}

export async function getAllTransport() {
  const snap = await getDocs(collection(db, TRANSPORT_COLLECTION));
  const items = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  return sortByOrder(items);
}

/** Uploads/replaces the hero image for a transport listing. If replacing,
 * the old image at existingUrl is deleted after the new one succeeds. */
export async function uploadTransportImage(id, file, existingUrl) {
  const storageRef = ref(
    storage,
    `transport/${id}/${Date.now()}_${file.name}`,
  );
  const snap = await uploadOptimizedImage(storageRef, file);
  const url = await getDownloadURL(snap.ref);

  if (existingUrl) {
    try {
      await deleteObject(ref(storage, existingUrl));
    } catch (err) {
      console.warn("Old transport image cleanup failed:", err);
    }
  }

  return url;
}